module.exports = __webpack_public_path__ + "img/fcca4c0.webp";